import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Router, Switch } from 'react-router';
/*
    In-house replacement for connected-react-router's <ConnectedRouter>, which is unmaintained
    (last published 2022) and needed a PropsWithChildren cast to render children at all:
    https://github.com/supasate/connected-react-router/issues/573

    Dispatches the same '@@router/LOCATION_CHANGE' action shape connected-react-router used, so
    the reducers in @as-react/as-react that read `state.router` keep working unchanged.
*/
const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
const injectQuery = (location) => {
    const search = location?.search;
    if (typeof search !== 'string' || search.length === 0) {
        return { ...location, query: {} };
    }
    const query = search
        .substring(1)
        .split('&')
        .reduce((acc, pair) => {
        const [key, value] = pair.split('=');
        acc[key] = value;
        return acc;
    }, {});
    return { ...location, query };
};
const RouterHistorySync = ({ history, children }) => {
    const dispatch = useDispatch();
    const hasDispatchedInitial = useRef(false);
    useEffect(() => {
        if (!hasDispatchedInitial.current) {
            hasDispatchedInitial.current = true;
            dispatch({
                type: LOCATION_CHANGE,
                payload: { location: injectQuery(history.location), action: history.action, isFirstRendering: true },
            });
        }
        const unlisten = history.listen((location, action) => {
            dispatch({
                type: LOCATION_CHANGE,
                payload: { location: injectQuery(location), action, isFirstRendering: false },
            });
        });
        return unlisten;
    }, [dispatch, history]);
    return _jsx(Router, { history: history, children: children });
};
export const WrapWithRouterReduxContainer = (BaseComponent, { history }) => function RouterReduxWrapper(props) {
    return (_jsx(RouterHistorySync, { history: history, children: _jsx(Switch, { children: _jsx(Route, { path: "/", render: () => _jsx(BaseComponent, { ...props }) }) }) }));
};
